import { CityCard } from "components";

export default function TopCity() {
  const cityList = [
    {
      id: 1,
      name: "Kuala Lumpur",
      image: "/images/kuala-lumur.png",
    },
    {
      id: 2,
      name: "Selangor",
      image: "/images/selangor.png",
    },
    {
      id: 3,
      name: "Perak",
      image: "/images/perak.png",
    },
    {
      id: 4,
      name: "Sabah",
      image: "/images/sabah.png",
    },
    {
      id: 5,
      name: "Johor",
      image: "/images/johor.png",
    },
    {
      id: 6,
      name: "Terengganu",
      image: "/images/terengganu.png",
    },
    {
      id: 7,
      name: "Penang",
      image: "/images/penang.png",
    },
    {
      id: 8,
      name: "Melacca",
      image: "/images/melacca.png",
    },
    {
      id: 9,
      name: "Kedah",
      image: "/images/kedah.png",
    },
  ];

  return (
    <div className="w-full mb-[40px] md:mb-[60px]">
      <div className="lex-1 text-base md:text-[32px] lg:leading-8 font-semibold text-black mb-3">
        Top cities
      </div>
      <div className="text-base text-[#112211] mb-10 block lg:hidden">
        Lorem ipsum is a placeholder text commonly used to demonstrate.
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 md:gap-8">
        {cityList.map((item, index) => (
          <CityCard key={index} data={item} />
        ))}
      </div>
    </div>
  );
}
